import React from "react";

const Spinner = () => {
  return (
    <div className="spinnerWrap">
      <img
        className="spinner"
        src={`${process.env.PUBLIC_URL}/img/spinner.png`}
        alt="spinner"
      />
    </div>
  );
};
export default Spinner;
